import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const logout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  return (
    <header className="h-16 bg-white shadow-sm border-b flex items-center justify-between px-6">
      {/* LEFT */}
      <div className="flex items-center gap-3">
        <h1 className="font-semibold text-gray-800">
          Admin & Bidan Panel
        </h1>
      </div>

      {/* RIGHT */}
      <div className="relative">
        <button
          onClick={() => setOpen(o => !o)}
          className="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-gray-100 transition"
        >
          {/* AVATAR */}
          <div className="w-9 h-9 rounded-full bg-gradient-to-r from-purple-500 to-indigo-600 flex items-center justify-center text-white font-bold">
            A
          </div>

          <div className="text-left hidden md:block">
            <p className="text-sm font-semibold text-gray-800">
              Administrator
            </p>
            <p className="text-xs text-gray-500">
              Admin
            </p>
          </div>

          <ChevronIcon
            className={`w-4 h-4 text-gray-500 transition ${
              open ? "rotate-180" : ""
            }`}
          />
        </button>

        {/* DROPDOWN */}
        {open && (
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border overflow-hidden z-50">
            <button
              onClick={logout}
              className="w-full flex items-center gap-3 px-4 py-3 text-red-600 hover:bg-red-50 transition text-sm font-semibold"
            >
              <LogoutIcon className="w-5 h-5" />
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

/* =========================
   ICONS
========================= */

function ChevronIcon(props: any) {
  return (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}

function LogoutIcon(props: any) {
  return (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={1.5}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6A2.25 2.25 0 005.25 5.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
      />
    </svg>
  );
}
